// import { useState } from 'react';
import NumberFormat from 'react-number-format';
import { useSelector } from 'react-redux';



export const Cobranza = ({ dataForm, no_mostrar_detraccion }) => {
    const cantDecimales = 2

    const {
        local_simbolo,
        local_separacion_miles,
        local_separacion_decimales
    } = useSelector(state => state.general.info)

    const {
        separacion_miles,
        separacion_decimales,
        simbolo,
        total_factura,
        total_cobrado,
        total_por_cobrar,
        aplica_detraccion,
        porcentaje_detraccion = 12,
        total_detraccion
    } = dataForm

    return (
        <div className='p-compras-box-totales-cobro'>
            <div className='row'>
                <div className='col d-flex justify-content-between align-items-center'>
                    <h5>Montos a cobrar</h5>
                    {/* <button
                        onClick={handleVerDecimales}
                        style={{ border: 'none', background: 'none', textDecoration: 'underline', color: 'gray' }}
                    >
                        {`Ver con ${cantDecimales == 4 ? 2 : 4} decimales`}
                    </button> */}
                </div>
            </div>
            <div className='row mt-2 p-montos'>
                <div className='col-8 text-start'><span>Total a cobrar</span></div>
                <div className='col-4 text-end'>
                    <NumberFormat
                        value={parseFloat(total_factura)}
                        displayType={'text'}
                        thousandSeparator={separacion_miles}
                        decimalSeparator={separacion_decimales}
                        prefix={`${simbolo} `}
                        decimalScale={cantDecimales}
                        fixedDecimalScale
                    />
                </div>
            </div>
            <div className='row p-montos'>
                <div className='col-8 text-start'><span>Cobrado</span></div>
                <div className='col-4 text-end'>
                    <NumberFormat
                        value={parseFloat(total_cobrado)}
                        displayType={'text'}
                        thousandSeparator={separacion_miles}
                        decimalSeparator={separacion_decimales}
                        prefix={`${simbolo} `}
                        decimalScale={cantDecimales}
                        fixedDecimalScale
                    />
                </div>
            </div>
            <div className='row p-montos'>
                <div className='col-8 text-start'><span>Por cobrar</span></div>
                <div className='col-4 text-end'>
                    <NumberFormat
                        value={parseFloat(total_por_cobrar)}
                        displayType={'text'}
                        thousandSeparator={separacion_miles}
                        decimalSeparator={separacion_decimales}
                        decimalScale={cantDecimales}
                        prefix={`${simbolo} `}
                        fixedDecimalScale
                    />
                </div>
            </div>

            {cantDecimales === 4 &&
                < div className='row p-montos'>
                    <div className='col-8 text-start'><span>Dif</span></div>
                    <div className='col-4 text-end'>
                        <NumberFormat
                            value={parseFloat(total_por_cobrar)}
                            displayType={'text'}
                            thousandSeparator={separacion_miles}
                            decimalSeparator={separacion_decimales}
                            decimalScale={4}
                            prefix={`${simbolo} `}
                            fixedDecimalScale
                        />
                    </div>
                </div>
            }

            {(aplica_detraccion && !no_mostrar_detraccion) &&
                <>
                    <div className='row mt-3'>
                        <div className='col d-flex justify-content-between align-items-center'>
                            <h5 style={{ fontSize: '13px' }}>Aplicando detracción {porcentaje_detraccion || 12}%</h5>
                        </div>
                    </div>
                    <div className='row mt-2 p-montos'>
                        <div className='col-8 text-start'><span>A cuenta empresa</span></div>
                        <div className='col-4 text-end'>
                            <NumberFormat
                                // value={parseFloat(total_factura) * (1 - (parseFloat(porcentaje_detraccion) / 100))}
                                value={parseFloat(total_factura) - parseFloat(total_detraccion)}
                                displayType={'text'}
                                thousandSeparator={separacion_miles}
                                decimalSeparator={separacion_decimales}
                                prefix={`${simbolo} `}
                                decimalScale={cantDecimales}
                                fixedDecimalScale
                            />
                        </div>
                    </div>
                    <div className='row mt-2 p-montos'>
                        <div className='col-8 text-start'><span>Importe a depositar en BN</span></div>
                        <div className='col-4 text-end'>
                            <NumberFormat
                                value={parseFloat(total_detraccion || 0)}
                                displayType={'text'}
                                thousandSeparator={local_separacion_miles}
                                decimalSeparator={local_separacion_decimales}
                                prefix={`${local_simbolo} `}
                                decimalScale={cantDecimales}
                                fixedDecimalScale
                            />
                        </div>
                    </div>
                </>
            }

        </div>
    )
}